// Fixed production staff origin for links that must resolve outside the browser that generated
// them (emails, server-side notifications). Never `window.location.origin` — a notification
// fired from a dev/localhost session must still point at real staff, or the link is useless.
export const STAFF_APP_URL = 'https://staff.onthemove.com';
